import React from "react";
import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import { selectIsLoading } from "../redux/loading/loadingSlice";
import { selectIsError } from "../redux/error/errorSlice";

const LoadingCircle = () => {
  const isLoading = useSelector(selectIsLoading);
  const isError = useSelector(selectIsError);
  const errorMessage = useSelector((state) => state.error.message);

  return (
    <div>
      {isLoading && (
        <div className="flex flex-col justify-center items-center h-full">
          <CircularProgress className="flex" size="200px" />
          <div className="p-4">Loading. . .</div>
        </div>
      )}
      {isError && (
        <div className="flex justify-center items-center h-full">
          <p>{errorMessage}</p>
        </div>
      )}
    </div>
  );
};

export default LoadingCircle;
